import React from 'react'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import HeadMeta from '../components/HeadMeta'

const ContactPage = () => {
  return (
    <div>
      <HeadMeta title="お問い合わせ | 株式会社ベツダイ" description="株式会社ベツダイへのお問い合わせ先一覧です。" />
      <noscript>
        &lt;style&gt;body{'{'}visibility:visible{'}'}&lt;/style&gt;
      </noscript>
      <div className="c-page-sub__base">
        <div className="c-page-sub__header">
          <Header /> 
        </div>
        <div className="c-page-sub__breadcrumb">
          <div className="c-nav-breadcrumb">
            <ol>
              <li className="c-nav-breadcrumb__item"><a href="/">トップ</a></li>
              <li className="c-nav-breadcrumb__item" data-breadcrumb="current">お問い合わせ</li>
            </ol>
          </div>
        </div>
        <div className="c-page-sub__main">
          <main>
            <article>
              <div className="c-page-sub__title-page">
                <div className="c-title-page" data-page="default">
                  <h1><span data-lang="en">CONTACT</span><span data-lang="ja">お問い合わせ</span></h1>
                </div>
              </div>
              <div className="c-page-sub__content-main">
                <div className="c-content-main">
                  <section data-type="section">
                    <div className="contact-contents">
                      <p>住まいのお困りごと、<br data-type="sp" />ご相談は下記のリストから</p>
                      <table>
                        <tbody>
                          <tr className="contact-contents-item">
                            <th data-level="01" data-type="matter">お問い合わせ内容</th>
                            <th data-level="01" data-type="department">部署</th>
                            <th data-level="01" data-type="tel">TEL</th>
                            <th data-level="01" data-type="mail">MAIL</th>
                          </tr>
                          <tr>
                            <th data-level="02">住宅建築・注文住宅・住宅用地の売買について</th>
                            <td>住宅事業部</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-574-6332">097-574-6332</a></td>
                            <td><a className="outlink" href="https://betsudaihome.jp/reservations/new" target="_blank">ベツダイホームお問い合わせ</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">中古戸建・マンション 売買について</th>
                            <td>ベツダイ不動産</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-574-6333">097-574-7161</a></td>
                            <td><a className="outlink" href="https://fudosan.betsudai.jp/" target="_blank">ベツダイ不動産</a><br />
                            <a className="outlink" href="https://portal.betsudai.jp/" target="_blank">ベツダイの不動産ポータル</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">リフォーム・増改築について</th>
                            <td>ベツダイリホーム</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-574-6336">097-574-6336</a></td>
                            <td><a className="outlink" href="https://betsudairehome.jp/form/" target="_blank">ベツダイリホーム</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">新築をご購入いただいたお客さまのお困りごと</th>
                            <td>お客様サポートセンター</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-574-7255">097-574-7255</a></td>
                            <td></td>
                          </tr>
                          <tr>
                            <th data-level="02">リフォーム・リノベーション工事をいただいた<br data-type="pc" />お客さまのお困りごと</th>
                            <td>ベツダイリホーム</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-574-6336">097-574-6336</a></td>
                            <td><a className="outlink" href="https://betsudairehome.jp/form/" target="_blank">ベツダイリホーム</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">賃貸物件をお探しの方</th>
                            <td>賃貸営業課</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-533-6000">097-533-6000</a></td>
                            <td><a className="outlink" href="//rent.betsudai.jp/contact/" target="_blank">ベツダイの賃貸お問い合わせ</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">賃貸物件入居者様用窓口、賃貸物件の管理、<br data-type="pc" />車庫証明の発行について</th>
                            <td>賃貸管理課</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:0120-300-118">0120-300-118</a></td>
                            <td data-pconly />
                          </tr>
                          <tr>
                            <th data-level="02">賃貸物件の管理のご相談、オーナー様窓口</th>
                            <td>不動産賃貸管理課</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:0120-300-118">0120-300-118</a></td>
                            <td><a className="outlink" href="https://ap.betsudai.jp/contact/" target="_blank">ベツダイの賃貸管理お問い合わせ</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">分譲マンション管理、分譲マンションアフター窓口</th>
                            <td>不動産分譲管理課</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-533-2471">097-533-2471</a></td>
                            <td><a className="outlink" href="//mansion-mgmt.betsudai.jp/contact/" target="_blank">ベツダイのマンション管理お問い合わせ</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">資産運用・アパート建築について</th>
                            <td>資産活用課</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-574-6807">097-574-6807</a></td>
                            <td><a className="outlink" href="//ap.betsudai.jp/contact/" target="_blank">ベツダイの資産活用お問い合わせ</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">新築分譲マンション購入のご相談</th>
                            <td>マンション事業本部</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-547-9640">097-547-9640</a></td>
                            <td><a target='_blank' href="https://greenhill.betsudai.jp/">グリーンヒル</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">星生倶楽部会員様用お問い合わせ窓口</th>
                            <td>星生倶楽部管理棟</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:0973-79-3316">0973-79-3316</a></td>
                            <td><a className="outlink" href="//hosshoclub.jp/contact/" target="_blank">星生倶楽部お問い合わせ</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">星生平売買について</th>
                            <td>星生倶楽部管理棟</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:0973-79-3316">0973-79-3316</a></td>
                            <td data-pconly />
                          </tr>
                          <tr>
                            <th data-level="02">LIFE LABEL、Doliveメディアパートナーの<br className="spNone" />フランチャイズ事業について</th>
                            <td>東京支社</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:03-4400-7890">03-4400-7890</a></td>
                            <td><a className="outlink" href="//tokyo.betsudai.co.jp/contact/" target="_blank">BETSUDAI Inc. TOKYOお問い合わせ</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">福岡の住宅建築・注文住宅・住宅用地の
                              <br className="spNone" />売買について</th>
                            <td>FUKUOKA OFFICE</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:092-918-1633">092-918-1633</a></td>
                            <td><a target='_blank' href="https://fukuoka.betsudaihome.jp/form/">ベツダイホーム福岡</a></td>
                          </tr>
                          <tr>
                            <th data-level="02">その他お問い合わせ</th>
                            <td>代表</td>
                            <td><i className="fa fa-phone" aria-hidden="true" /><a className="telLink" href="tel:097-574-6330">097-574-6330</a></td>
                            <td data-pconly />
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </section>
                </div>
              </div>
            </article>
          </main>
        </div>
        <div className="c-page-sub__footer">
          <Footer />
        </div>
      </div>
    </div>

  )
}

export default ContactPage
